import React, { useState, useEffect, useContext } from 'react';
import { FaCheckCircle, FaClock, FaCalendarAlt, FaGift, FaEnvelope, FaHeadset } from 'react-icons/fa';
import { TbArrowBigDownLinesFilled } from "react-icons/tb";
import { motion } from 'framer-motion';
import Footer from '../../components/Footer';
import DownloadItems from './Components/ThankYouPage/DownloadItems';
import Features from './Components/ThankYouPage/Features';
import Instructions from './Components/ThankYouPage/Instructions';
import Bonuses from './Components/ThankYouPage/Bonuses';
import CommunitySection from './Components/ThankYouPage/CommunitySection ';
import SocialProof from './Components/ThankYouPage/SocialProof';
import CountDown from './Components/ThankYouPage/CountDown';
import { ThankYouContext } from './context/ThankYouContext';
import { PixelContext } from '../Context/PixelContext';
import { initFacebookPixel, trackEvent } from '../../pixel';

const ThankYou = () => {

  const { 
        loading,
        error,
        imageUrl,
        slug,
        thankYouPage,
        apiUrl
      } = useContext(ThankYouContext);

      console.log(thankYouPage, "thankYouPage");

      

  // ডিফল্ট কালার সেট (WebinarHome কম্পোনেন্টের শুরুতে)
  const [gradientClass, setGradientClass] = useState('bg-gradient-to-b from-blue-600 to-indigo-700');
  const [freethings, setFreeThing] = useState([]);
  const [finishBonuses, setFinishBonuses] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [instructions, setInstructions] = useState([]);
  const [socialProofs, setSocialProofs] = useState([]);

  const { pixel } = useContext(PixelContext);
  const pixelId = pixel?.pixel_id || null;

   useEffect(() => {
      setFreeThing(thankYouPage.freethings || []);
      setFinishBonuses(thankYouPage.finish_bonuses_header || []);
      setCommunities(thankYouPage.communities || []);
      setInstructions(thankYouPage.joining_instructions || []);
      setSocialProofs(thankYouPage.social_proofs || []);

    }, [thankYouPage]);

  useEffect(() => {
  if (pixelId) {
    // Initialize if not already done
    initFacebookPixel(pixelId);
    
    // Track thank you page specific events
    trackEvent('CompleteRegistration');
    
  }
}, [pixelId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gradient-to-br from-blue-50 to-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Preparing your exclusive access...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen bg-gradient-to-br from-red-50 to-white">
        <div className="bg-white p-8 rounded-xl shadow-xl text-center max-w-md">
          <div className="text-red-500 text-5xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Oops! Something went wrong</h2>
          <p className="text-gray-600 mb-6">We're having trouble loading your registration details.</p>
          <button 
            onClick={() => window.location.reload()}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Confirmation Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className={`flex items-center justify-center py-6 gap-4 ${gradientClass} text-white text-center px-4 shadow-lg`}
      >
        <FaCheckCircle className="text-white text-4xl md:text-5xl animate-bounce" />
        <div>
          <h1 className="text-xl md:text-2xl font-bold">{thankYouPage.topBar}</h1>
          {/* <p className="text-sm md:text-base opacity-90 mt-1">
            Your spot has been reserved successfully!
          </p> */}
        </div>
      </motion.div>

      {/* Main Content */}
      <div className="container mx-auto py-12 px-4 max-w-6xl">
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-center mb-16"
        >
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 leading-tight">
            {thankYouPage.headline}
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            {thankYouPage.subHeadline}
          </p>
        </motion.div>

        <div className="flex flex-col lg:flex-row gap-8 items-start">
          {/* Left Column - Content */}
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
            className="w-full lg:w-2/3"
          >
         

            {/* Media Content */}
            <div className="rounded-xl overflow-hidden shadow-xl mb-8 transition-all duration-300 hover:shadow-2xl">
              {Number(thankYouPage.showImage) === 1 ? (
                <div className="bg-gray-200 h-64 flex items-center justify-center">
                  <span className="text-gray-500"><img src={`${imageUrl}/${thankYouPage.image}`} /></span>
                </div>
              ) : (
                <div className="relative aspect-w-16 aspect-h-9">
                  <iframe
                    className="w-full h-64 md:h-96 lg:h-[500px] rounded-lg"
                    src={`https://www.youtube.com/embed/${thankYouPage.video}`}
                    title="YouTube video player"
                    frameBorder={0}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
                </div>
              )}
            </div>


              
              
              {/* Rest of your existing content */}
              <DownloadItems freethings={freethings} />

              <div className='lg:hidden mb-4'>
                <CountDown thankYouPage={thankYouPage} />
              </div>
              
               {/* Add the Bonuses component here */}
              <Bonuses finishBonuses={finishBonuses} />
              {/* <Features webinarData={webinarData} /> */}
              <Instructions instructions={instructions} />
              
              <CommunitySection communities={communities} />
          </motion.div>

          {/* Right Column - Countdown */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
            className="w-full lg:w-1/3 sticky top-6"
          >
            <div className='hidden lg:block'>
              <CountDown thankYouPage={thankYouPage} />
            </div>
            <SocialProof socialProofs={socialProofs} />
          </motion.div>
        </div>
      </div>
      

      {/* Footer CTA */}
      <div className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-4 text-center">
          <h3 className="text-2xl font-bold mb-4">Need Immediate Assistance?</h3>
          <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
            Our dedicated support team is available 24/7 to answer your questions about the Masterclass or technical issues.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button className="bg-white text-gray-800 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
              <FaHeadset className="inline mr-2" /> Call Now: +8801635494643
            </button>
            <button className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
              <FaEnvelope className="inline mr-2" /> Email Support
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ThankYou;